import { useState, useEffect } from 'react';

/**
 * Custom hook for managing passkey section enabled/disabled state
 * Handles DOM event listener management and checkbox integration
 */
export const usePasskeySection = (contextType: string, currentPasskey: string): {
  isPasskeySectionEnabled: boolean;
  setIsPasskeySectionEnabled: (value: boolean) => void;
} => {
  const [isPasskeySectionEnabled, setIsPasskeySectionEnabled] = useState<boolean>(!!currentPasskey);

  /**
   * Sets up checkbox event listener for enabling/disabling passkey section
   * Integrates with legacy form toggle functionality
   */
  useEffect(() => {
    const handleToggle = (): void => {
      const checkbox = document.getElementById(
        `${contextType}_enable_simple_password`
      ) as HTMLInputElement | null;
      if (checkbox) {
        setIsPasskeySectionEnabled(checkbox.checked);
      }
    };

    const toggleElement = document.querySelector('.j-toggle-password');
    if (toggleElement) {
      toggleElement.addEventListener('change', handleToggle);
      handleToggle(); // Set initial state
    }

    return () => {
      if (toggleElement) {
        toggleElement.removeEventListener('change', handleToggle);
      }
    };
  }, [contextType]);

  return {
    isPasskeySectionEnabled,
    setIsPasskeySectionEnabled
  };
};
